import { useSelector, useDispatch } from 'react-redux'
import { useLocation } from 'react-router-dom'
import { useEffect, useState } from 'react'
import { useBreakpoint } from 'utils'
import { drawerActions, drawerSelectors, drawerTypes } from '../store/drawer'

/**
 * Custom hook for drawer management - provides a similar API to the original DrawerManagerContext
 * but uses Redux instead of React Context
 */
export const useDrawer = (options?: { forceHideNav?: boolean }) => {
  const dispatch = useDispatch()
  const { pathname } = useLocation()
  const viewPorts = useBreakpoint()

  // Get all required state from Redux store
  const drawerActive = useSelector(drawerSelectors.getDrawerActive)
  const drawerCompact = useSelector(drawerSelectors.getDrawerCompact)
  const isMobile = useSelector(drawerSelectors.getIsMobile)
  const displayMode = useSelector(drawerSelectors.getDisplayMode)
  const secondaryDrawerPresent = useSelector(
    drawerSelectors.getSecondaryDrawerPresent
  )
  const padding = useSelector(drawerSelectors.getDrawerPadding)
  const lastViewport = viewPorts.reverse()[0]
  console.log('useDrawer: lastViewport =', lastViewport)

  // Set force hide nav from props
  // useEffect(() => {
  //   if (options?.forceHideNav !== undefined) {
  //     console.log('useDrawer: Setting forceHideNav to', options.forceHideNav)
  //     dispatch(drawerActions.setForceHideNav(options.forceHideNav) as any)
  //   }
  // }, [dispatch, options?.forceHideNav])

  // Update mobile state when viewport changes
  // useEffect(() => {
  //   if(lastViewport !== maxViewport) {
  //     const newIsMobile = !viewPorts.includes('md')
  //     dispatch(drawerActions.setMobileState(newIsMobile) as any)
  //     setMaxViewport(lastViewport)
  //   }
  // }, [dispatch, viewPorts, lastViewport, setMaxViewport])

  // Mobile route change effect
  useEffect(() => {
    if (typeof window !== 'undefined') {
      if (lastViewport === 'sm') {
        dispatch(drawerActions.setForceHideNav(true) as any)
        if (!isMobile) {
          dispatch(drawerActions.setMobileState(true) as any)
        }
      } else {
        if (isMobile) {
          dispatch(drawerActions.setMobileState(false) as any)
        }
      }
    }
  }, [dispatch, pathname, lastViewport, isMobile])

  // Toggle drawer function - can either toggle current state or set to specific state
  const toggleDrawer = (newState?: boolean) => {
    console.log(
      'useDrawer: toggleDrawer called with',
      newState,
      'current state is',
      drawerActive
    )

    // Always dispatch the toggle action - we'll fix the issue in the reducer
    console.log('useDrawer: Dispatching TOGGLE_DRAWER action')
    dispatch(drawerActions.toggleDrawer() as any)
  }

  // Use display mode function (equivalent to the context version)
  const useDisplayMode = (newMode: drawerTypes.DrawerDisplayMode) => {
    if (newMode === displayMode) {
      return
    }
    console.log('useDrawer: Setting display mode to', newMode)
    dispatch(drawerActions.setDrawerMode(newMode) as any)
  }

  return {
    drawerActive,
    drawerCompact,
    toggleDrawer,
    useDisplayMode,
    padding,
    secondaryDrawerPresent,
    displayMode,
    isMobile,
  }
}
